export default __webpack_public_path__ + "static/media/05_photo.a10dc577.jpg";